import {APPEND_TO_PAYLOAD_PROP_NAME} from '../../constants';

export function appendToPayload(el, payload) {
	const appendToPayload = el[APPEND_TO_PAYLOAD_PROP_NAME];
	if (!appendToPayload) return payload;

	return {...payload, ...appendToPayload};
}
